import { render } from "./OTPVerificationModal.vue?vue&type=template&id=03ba9b46"
import script from "./OTPVerificationModal.vue?vue&type=script&lang=js"
export * from "./OTPVerificationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__